import { qcOutcomeLabel, type QcOutcomeType } from '@/types';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { cssVar } from '@nautilusbio/nb-design-system/styles/css-variables';
import clsx from 'clsx';
import React, { type FC } from 'react';

import styles from './styles.module.css';

const dotColor: Record<QcOutcomeType, string> = {
  pass: cssVar.color.success,
  warn: cssVar.color.yellow,
  fail: cssVar.color.danger,
  not_applicable: cssVar.color.textGray,
  // Deliberately not textGray: "QC hasn't run yet" must not read as the determinate
  // "this check doesn't apply". Blue signals in-flight rather than absent.
  not_computed: cssVar.color.lightBlue,
};

type QCBadgeProps = {
  className?: string;
  qc: QcOutcomeType;
};

const QCBadge: FC<QCBadgeProps> = ({ className, qc }) => (
  // No null branch: QC fields are non-nullable — absence is the 'not_computed' value.
  <Stack alignItems="center" as="span" className={className} gap={2} orientation="horizontal">
    <span className={clsx(styles.dot)} style={{ backgroundColor: dotColor[qc] }} />
    {qcOutcomeLabel(qc)}
  </Stack>
);

export default QCBadge;
